import { NgTemplateOutlet } from '@angular/common'
import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type {
  EditorDto,
  EditorsResponseDto,
} from '../../../../../api/responses'
import { FormatAuthorNamePipe } from '../../../../../shared/pipes/format-author-name.pipe'

interface EditorWithType extends Omit<EditorDto, 'type'> {
  type: keyof EditorsResponseDto['editors']
}

@Component({
  selector: 'dhp-editor-item',
  templateUrl: './editor-item.component.html',
  styleUrls: ['./editor-item.component.css'],
  imports: [NgTemplateOutlet, TranslatePipe, FormatAuthorNamePipe],
})
export class EditorItemComponent {
  readonly editor = input.required<EditorWithType>()

  get personLink(): EditorDto {
    return {
      ...this.editor(),
      type: 'editor',
    }
  }
}
